export default __webpack_public_path__ + "static/media/jhonathan-osorio-at-caq-soccer-6-of-43.0d724341.jpeg";